// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__merriweatherBoldItalic_c92174', '__merriweatherBoldItalic_Fallback_c92174', s, e, r, i, f","fontStyle":"normal"},"className":"__className_c92174"};